var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',[_vm._v(_vm._s(this.src))]),_vm._v(" "),_c('iframe',{staticStyle:{"width":"100%","height":"100%","frameborder":"0","position":"absolute","top":"0"},attrs:{"src":_vm.iframeSrc}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d9a9809","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recallInfo.vue
// module id = null
// module chunks = 